import { useState } from 'react';

export default function Services() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-layout-line',
      title: 'Custom Website Design',
      description: 'Tailored websites that reflect your professional brand and attract ideal clients in the court reporting industry.',
      features: [
        'Mobile-responsive design',
        'Professional branding',
        'User-friendly interface',
        'Fast loading speeds',
        'ADA compliant'
      ],
      popular: false
    },
    {
      icon: 'ri-search-line',
      title: 'SEO Optimization',
      description: 'Dominate local search results and get found by attorneys and legal professionals searching for court reporters.',
      features: [
        'Local SEO strategy',
        'Keyword optimization',
        'Google My Business',
        'Content marketing',
        'Monthly reporting'
      ],
      popular: true
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Ongoing Support',
      description: 'Reliable maintenance and updates to keep your website secure, current, and performing at its best.',
      features: [
        '24/7 technical support',
        'Regular updates',
        'Security monitoring',
        'Content updates',
        'Performance optimization'
      ],
      popular: false
    }
  ];

  return (
    <section className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-[#FF6B6B] text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
            Our Services
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl font-bold text-[#1A2332] mb-4">
            Specialized Solutions for Court Reporting Professionals
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Everything you need to establish a powerful online presence and attract more clients
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              className={`bg-white rounded-2xl p-8 shadow-lg transition-all duration-300 cursor-pointer relative ${
                hoveredCard === index ? 'transform scale-105 shadow-2xl' : ''
              } ${index === 1 ? 'md:mt-8' : ''} ${index === 2 ? 'md:mt-16' : ''}`}
            >
              {service.popular && (
                <div className="absolute top-4 right-4 bg-[#FF6B6B] text-white px-3 py-1 rounded-full text-xs font-semibold">
                  Most Popular
                </div>
              )}

              {/* Icon */}
              <div className="w-16 h-16 bg-[#FF6B6B]/10 rounded-xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-[#FF6B6B]`}></i>
              </div>

              {/* Title */}
              <h3 className="font-['Playfair_Display'] text-2xl font-bold text-[#1A2332] mb-4">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-3 mb-6">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#FF6B6B] text-lg mt-0.5"></i>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Learn More Link */}
              <a
                href="#contact"
                className={`inline-flex items-center text-[#FF6B6B] font-semibold text-sm transition-all cursor-pointer ${
                  hoveredCard === index ? 'translate-x-1' : ''
                }`}
              >
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-4">Need a custom solution?</p>
          <a
            href="#contact"
            className="inline-flex items-center bg-[#1A2332] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#2a3342] transition-colors whitespace-nowrap cursor-pointer"
          >
            Schedule a Consultation
            <i className="ri-calendar-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
